import React, { useEffect, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BufferService } from '../utils/buffer.service'
import '../Cancellations/cancellations.css'
import LoadingContext from '../utils/loading.context'

export default function CrediCardSuccess() {
    const ctx = useContext(LoadingContext)
    const navigate = useNavigate()
    const location = useLocation()
    const BackendPut = new BufferService('payments/CreditCard')
    const urlParam = decodeURIComponent(location.search.replace("?", ""))

    useEffect(() => {
        const regex = /([^&=]+)=([^&]*)/g
        let match
        const params = {}

        while ((match = regex.exec(urlParam)) !== null) {
            params[decodeURIComponent(match[1])] = decodeURIComponent(match[2])
        }

        let tempValues = {
            'Type': "success",
            'Amount': params['amount'] || "",
            'Id': params['id'] || "",
            'RequestId': params['requestId'] || "",
            'Sk': params['sk'] || "",
        }

        BackendPut.put(tempValues).then(post => {
            if (post.name === 'AxiosError') {
                ctx.toastMessages('error', '', "Algo correu mal, tente novamente!")
                return
            }
        })
    }, [])

    return (
        <>
            <div style={{ marginTop: '25px' }} className='spanNoteCancelV2'>
                <h1 style={{ textTransform: 'inherit', color: 'green' }}>Transação realizada com Sucesso</h1>
            </div>
            <div style={{ marginTop: '25px' }} className='spanNoteCancelV2'>
                <span style={{ fontSize: '20px', textTransform: 'inherit' }}>O pedido foi processado com êxito e em breve será informado por email pelo CIF da confirmação da reserva.</span>
            </div>
            <div className='divCancelButtonV2'>
                <button onClick={() => navigate("/")} className='buttonCancelV2'>
                    Voltar
                </button>
            </div>
        </>
    )
}